module.exports = __webpack_public_path__ + "img/buisnes.a6e45f77.jpg";